// extracted by mini-css-extract-plugin
export var wrapper = "Logotype-module--wrapper--3pUGB";
export var logo = "Logotype-module--logo--3UFb9";
export var artwork = "Logotype-module--artwork--2Zba5";